import { useQueries } from '@tanstack/react-query';

import { Reservation } from '@luxuryescapes/contract-svc-reservation';

import ReservationService from '~/services/ReservationService';

const propertyQueryKeys = {
  all: ['reservation', 'properties'] as const,
  details: () => [...propertyQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...propertyQueryKeys.details(), id] as const,
};

export function useGetPropertiesByIds(propertyIds: Array<string>) {
  const { propertyMap, isLoading, isError } = useQueries({
    queries: propertyIds.map((propertyId) => ({
      queryKey: propertyQueryKeys.detail(propertyId),
      queryFn: async ({ signal }) => {
        const response = await ReservationService.getProperty<Reservation.Property>(propertyId, { signal });
        return {
          propertyId,
          property: response?.result,
        };
      },
      enabled: !!propertyId,
      staleTime: 5 * 60 * 1000,
    })),
    combine: (results) => {
      const fetchedPropertiesById = new Map<string, Reservation.Property>();
      for (const result of results) {
        if (result.data?.property) {
          fetchedPropertiesById.set(result.data.propertyId, result.data.property);
        }
      }
      return {
        propertyMap: fetchedPropertiesById,
        isLoading: results.some((result) => result.isLoading),
        isError: results.some((result) => result.isError),
      };
    },
  });

  return {
    propertyMap,
    isLoading,
    isError,
  };
}
